/* eslint-disable */
export default {
  dncAlert: 'Este contato está em uma lista de Não ligar.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
